
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-integrations/razorpay",
      function () {
        return require("private-next-pages/whatsapp-integrations/razorpay.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-integrations/razorpay"])
      });
    }
  